import { Megaphone } from "lucide-react";

export function AdCard({ compact }) {
  return (
    <a href="mailto:reklam@ustayla.com" data-testid="ad-slot"
      className={`block rounded-2xl border-2 border-dashed border-amber-300 bg-amber-50/60 hover:bg-amber-50 transition-colors ${compact ? "p-4" : "p-6"} text-center`}>
      <div className="flex flex-col items-center gap-1.5 text-amber-700">
        <Megaphone className={compact ? "h-6 w-6" : "h-7 w-7"} />
        <div className="font-bold text-sm">📢 Reklam Alanı</div>
        <div className="text-xs text-amber-600/80">Buraya reklam vermek için tıklayın</div>
      </div>
    </a>
  );
}
